export default __webpack_public_path__ + "static/media/WooStoreFront1.b5023c50.jpeg";